import {
  occasionTypes,
  deliveryFeeVariants as variants,
} from '@/src/utils/constants';
import { translate } from '@/src/utils/translate/translate';
import Typography from '@pedidosya/web-fenix/foundations/Typography';
import Fleet from '@pedidosya/web-fenix/icons/Fleet';
import styled from 'styled-components';
import { Row, TextSeparator } from '../styles/styles';
import { vendorItem } from '../styles/vendorItem';

export const TypographyWeb = styled(Typography)`
  &.original-fee {
    align-self: center;
    margin-left: ${({ theme }) => theme.space('spacing-component-small')};
  }
`;

const a11yLabels = translate.ARG_UY.vendorItem;
const textProps = vendorItem.properties.fonts;

const renderDeliveryFee = (deliveryFee, deliveryFeeWithDiscount, variant) => {
  const deliveryFeeVariants = {
    [variants.default]: () => (
      <TypographyWeb
        color={textProps.feeDefault.textColor}
        token={textProps.feeDefault.typography}
      >
        Envío {deliveryFee}
      </TypographyWeb>
    ),
    [variants.free]: () => (
      <TypographyWeb
        color={textProps.feeFree.textColor}
        token={textProps.feeFree.typography}
      >
        Envío gratis
      </TypographyWeb>
    ),
    [variants.variable]: () => (
      <TypographyWebWeb
        color={textProps.feeVariable.textColor}
        token={textProps.feeVariable.typography}
      >
        Envío variable
      </TypographyWebWeb>
    ),
    [variants['plus-free']]: () => (
      <>
        <TypographyWeb
          color={textProps.feePlusFree.textColor}
          token={textProps.feePlusFree.typography}
          data-testid="plus-free"
        >
          Envío gratis
        </TypographyWeb>
      </>
    ),
    [variants['plus-discount']]: () => (
      <>
        <PeyaPlusChip
          aria-label={a11yLabels.shipping.plusDiscount}
          viewBox="0 0 36 14"
        />
        <TypographyWeb
          color={textProps.feePlusDiscount.textColor}
          token={textProps.feePlusDiscount.typography}
        >
          Envío {deliveryFeeWithDiscount}
        </TypographyWeb>
        <TypographyWeb
          className="original-fee"
          color={textProps.originalFee.textColor}
          token={textProps.originalFee.typography}
        >
          {deliveryFee}
        </TypographyWeb>
      </>
    ),
  };

  return deliveryFeeVariants[variant]?.() || null;
};

export const ShippingInfoRow = ({
  occasion,
  deliveryTime,
  pickupTime,
  deliveryFee,
  deliveryFeeWithDiscount,
  deliveryETAVariant,
  deliveryFeeVariant,
  distance,
  hasSurgeFee,
}) => (
  <Row
    paddingTop="spacing-component-xsmall"
    paddingBottom="spacing-component-xsmall"
    color={textProps.feeDefault.textColor}
    token={textProps.feeDefault.typography}
  >
    {occasion.toLowerCase() === occasionTypes.delivery && (
      <>
        <TypographyWeb
          aria-label={a11yLabels.ETA[deliveryETAVariant]}
          color={
            textProps[
              `eta${
                deliveryETAVariant.charAt(0).toUpperCase() +
                deliveryETAVariant.slice(1)
              }`
            ].textColor
          }
          token={
            textProps[
              `eta${
                deliveryETAVariant.charAt(0).toUpperCase() +
                deliveryETAVariant.slice(1)
              }`
            ].typography
          }
        >
          {deliveryTime}
        </TypographyWeb>
        <TextSeparator>·</TextSeparator>
        {renderDeliveryFee(
          deliveryFee,
          deliveryFeeWithDiscount,
          deliveryFeeVariant,
        )}
        {hasSurgeFee && (
          <Fleet size="small" color={textProps.feeDefault.textColor} />
        )}
      </>
    )}
    {occasion.toLowerCase() === occasionTypes.pickup && (
      <>
        <TypographyWeb token={textProps.feeDefault.typography}>
          {pickupTime}
        </TypographyWeb>
        {!!pickupTime && !!distance && <TextSeparator>·</TextSeparator>}
        <TypographyWeb token={textProps.feeDefault.typography}>
          {distance}
        </TypographyWeb>
      </>
    )}
  </Row>
);
